import Cookies from 'universal-cookie';

/**
 * if hosted on the marketplace platform
 */
export const isMarketplacePlatform = (): boolean => {
  // Matches lower env host (marketplace.*env.chownow.com)
  // Matches legacy (eat.chownow.com) and current (www.chownow.com) Marketplace URLs
  const MARKETPLACE_REGEX = /(marketplace)|(eat)|(www)/;
  const cookies = new Cookies();
  return (
    MARKETPLACE_REGEX.test(window.location.hostname) ||
    cookies.get('cn_platform') === 'marketplace'
  );
};

/**
 * if hosted on the yelp platform
 */
export const isYelpPlatform = (): boolean => {
  const YELP_REGEX = /yelp\./;
  const cookies = new Cookies();
  return (
    YELP_REGEX.test(window.location.hostname) ||
    cookies.get('cn_platform') === 'yelp'
  );
};
